// src/report/ArchitectureDashboard.jsx

import React from "react";

export default function ArchitectureDashboard({ analysis, repo, advice }) {

    if (!analysis) {
        return (
            <div>
                No analysis data
            </div>
        );
    }

    const data = analysis.data ?? analysis;

    console.log("OVERVIEW REPO:", {repo, summaryRepo: analysis?.repo});

    return (

        <section style={{ padding: "24px" }}>

            <h1 style={{ marginBottom: "24px" }}>
                Architecture Overview
            </h1>

            <div
                style={{
                    display: "grid",
                    gridTemplateColumns: "repeat(auto-fit, minmax(220px, 1fr))",
                    gap: "16px",
                    marginBottom: "32px"
                }}
            >

                <div
                    style={{
                        border: "1px solid #333",
                        borderRadius: "12px",
                        padding: "16px"
                    }}
                >
                    <div style={{ fontSize: "12px", opacity: 0.7 }}>
                        Repository
                    </div>

                    <div style={{ fontSize: "20px", fontWeight: 700 }}>
                        {repo || "-"}
                    </div>
                </div>


                <div
                    style={{
                        border: "1px solid #333",
                        borderRadius: "12px",
                        padding: "16px"
                    }}
                >
                    <div style={{ fontSize: "12px", opacity: 0.7 }}>
                        Risk
                    </div>

                    <div style={{ fontSize: "20px", fontWeight: 700 }}>
                        {data.repositoryRisk || "-"}
                    </div>
                </div>


                <div
                    style={{
                        border: "1px solid #333",
                        borderRadius: "12px",
                        padding: "16px"
                    }}
                >
                    <div style={{ fontSize: "12px", opacity: 0.7 }}>
                        Architecture Risk Score (0-100)
                    </div>

                    <div style={{ fontSize: "20px", fontWeight: 700 }}>
                        {data.overallScore ?? 0}
                    </div>
                </div>

            </div>


            <section style={{ marginBottom: "32px" }}>

                <h2 style={{ marginBottom: "16px" }}>
                    Main Problems
                </h2>

                {Array.isArray(data.topProblems) && data.topProblems.length > 0 ? (

                    <div
                        style={{
                            display: "flex",
                            flexDirection: "column",
                            gap: "12px"
                        }}
                    >

                        {data.topProblems.slice(0, 10).map((p, i) => (

                            <div
                                key={i}
                                style={{
                                    border: "1px solid #2a2a2a",
                                    borderRadius: "10px",
                                    padding: "14px"
                                }}
                            >

                                <div style={{ fontWeight: 700, marginBottom: "4px" }}>
                                    {p.category || "Problem"}
                                </div>

                                <div style={{ opacity: 0.9, marginBottom: "4px" }}>
                                    {p.file || p.target || "Unknown file"}
                                </div>

                                {p.description && (
                                    <div style={{ fontSize: "14px", opacity: 0.75 }}>
                                        {p.description}
                                    </div>
                                )}

                            </div>

                        ))}

                    </div>

                ) : (

                    <div style={{ opacity: 0.7 }}>
                        No major problems detected
                    </div>

                )}

            </section>

            <section style={{ marginBottom: "32px" }}>

                <h2 style={{ marginBottom: "16px" }}>
                    Architecture Explanation
                </h2>

                <div
                    style={{
                        border: "1px solid #333",
                        borderRadius: "12px",
                        padding: "16px",
                        lineHeight: 1.6
                    }}
                >

                    {data.explanation?.architectureOverview ||
                        "Architecture analysis is available after dependency and risk evaluation."}

                </div>

            </section>


            <section>

                <h2 style={{ marginBottom: "16px" }}>
                    Refactoring Suggestions
                </h2>

                {Array.isArray(advice?.repositoryFiles) && advice.repositoryFiles.length > 0 ? (

                    <div
                        style={{
                            display: "flex",
                            flexDirection: "column",
                            gap: "10px"
                        }}
                    >

                        {advice.repositoryFiles.slice(0, 5).map((item, i) => (

                            <div
                                key={i}
                                style={{
                                    border: "1px solid #2a2a2a",
                                    borderRadius: "10px",
                                    padding: "14px"
                                }}
                            >

                                <div style={{ fontWeight: 700 }}>
                                    {item.identity?.className || item.target || "Suggestion"}
                                </div>

                                {item.rootCause && (
                                    <div style={{ marginTop: "6px", opacity: 0.8 }}>
                                        {item.rootCause}
                                    </div>
                                )}

                            </div>
                        ))}
                    </div>
                ) : (
                    <div style={{ opacity: 0.7 }}>
                        No prioritized refactoring actions generated yet.
                    </div>
                )}
            </section>
        </section>
    );
}